var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15l-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseImage);
export default __webpack_public_path__ + "static/media/choose_image.03ba8ae5a8d435fc6071938eff708f4e.svg";
export { ForwardRef as ReactComponent };